// External links
export const BearBlitz = "https://bearbitz.in/";
export const LicknChew = "https://licknchew.in/";
// Social Links
export const WhatsApp = "https://wa.me/919363088257";
export const Insatagram = "https://www.instagram.com/ponvelexim";
export const Youtube = "https://www.youtube.com/@PONVELEXIM";
export const Facebook =
  "https://www.facebook.com/profile.php?id=61574941850734";
//Menu Link
export const RootURL = "/";
export const Soon = "/coming-soon";
export const Company = "/our-company";
export const ContactUs = "/contact";
export const Picture = "/picture";
export const Videos = "/videos";
export const Certificate = "/certificate";
export const PrivacyPolicy = "/privacy-policy";
